__webpack_require__.p = "/mi-assets/mi-static/mi-luxury-renderer/web-rel-26.2.1-02072026/_next/";